import { render, staticRenderFns } from "../templates/normal_fcont_151.html?vue&type=template&id=3f1a5b9a&scoped=true&"
import script from "./normal_fcont_151.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_151.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1a5b9a",
  null
  
)

export default component.exports